<style scoped>
.title {
  color: #444444;
  font-size: 24px;
}

.title hr {
  margin: 0;
  width: 35%;
}

.loading-container {
  min-height: 260px;
}

.stat-container {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  border: 1px solid #dddddd;
  padding: 10px 0px;
  margin: 15px;
  text-align: center;
}

.stat-container .stat-title {
  font-size: .9rem;
  color: #444444;
}

.stat-container .stat-subtitle {
  font-size: 14px;
  color: #666666;
}

.stat-container .icon-container {
  color: #606060;
  text-align: center;
  line-height: 48px;
  font-size: 24px;
}
</style>

<template>
  <b-col>
    <b-row class="p-2">
      <b-col>
        <div class="title text-uppercase">
          Loan Summary
        </div>
      </b-col>
    </b-row>
    <b-row v-permission=permissionList>
      <b-col>
        <loading-component
          :url="`/users/${user.id}/monetary_summary`"
          error-message="Unable to load loan monetary summary"
          @success="onLoadHandler"
          class="loading-container"
        >
          <div v-if="hasLoans">
            <b-row>
              <b-col md="12" lg="6">
                <doughnut-chart ref="chart" :chartData="chart.data" :options="chart.options">
                </doughnut-chart>
              </b-col>
              <b-col md="12" lg="6">
                <div class="bottom-aligned">
                  <div
                    v-for="stat in stats"
                    v-bind:key="stat.title"
                    class="stat-container pointer-cursor"
                    @click="() => $router.push({
                      name: 'MyDeals',
                      query: { category: stat.category },
                    })"
                  >
                    <b-col>
                      <div class="stat-title"><span class="btn-link">{{ stat.title }}</span></div>
                      <div class="stat-subtitle">
                        {{ stat.subtitle }}
                      </div>
                    </b-col>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>
          <empty-loans v-else />
        </loading-component>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import jshelper from '@/libs/helper';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCoins,
  faMoneyBillWave,
  faHandHoldingUsd,
} from '@fortawesome/free-solid-svg-icons';

import DoughnutChart from '@/components/utils/charts/DoughnutChart';
import EmptyLoans from '@/components/profile/sections/stats/EmptyLoans';
import LoadingComponent from '@/components/utils/LoadingComponent';
import { LOANS_READ } from '@/libs/permissions_list';


library.add([faCoins, faMoneyBillWave, faHandHoldingUsd]);


export default {
  components: {
    DoughnutChart,
    EmptyLoans,
    LoadingComponent,
  },
  data() {
    return {
      chartSize: '250px',
      monetaryInfo: null,
      permissionList: [LOANS_READ],
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    isUserVerified() {
      return this.user.verified === true;
    },
    chart() {
      if (!this.monetaryInfo) { return null; }

      const info = this.monetaryInfo;
      const data = {
        labels: ['In Progress', 'Active', 'Paid'],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: ['#3e88c9', '#343a40', '#629c44'],
            data: [
              info.in_progress.total,
              info.active.total,
              info.paid.total,
            ],
          },
        ],
      };
      const options = {
        responsive: true,
        cutoutPercentage: 35,
      };
      return { data, options };
    },
    hasLoans() {
      const info = this.monetaryInfo;
      if (!info || !this.user.verified) { return false; }

      const total = info.in_progress.total + info.active.total + info.paid.total;
      return total > 0;
    },
    stats() {
      if (!this.monetaryInfo) { return []; }

      const loanStr = val => (val > 1 ? 'Loans' : 'Loan');
      const inProgress = this.monetaryInfo.in_progress;
      const active = this.monetaryInfo.active;
      return [
        {
          title: `${inProgress.total} In Progress ${loanStr(inProgress.total)}`,
          subtitle: `$ ${jshelper.currency(inProgress.amount)}`,
          category: 'in_progress',
        },
        {
          title: `${active.total} Active ${loanStr(active.total)}`,
          subtitle: `$ ${jshelper.currency(active.amount)}`,
          category: 'active',
        },
      ];
    },
  },
  methods: {
    onLoadHandler(data) {
      this.monetaryInfo = data;
    },
  },
  mounted() {
    const chart = this.$refs.chart;
    if (chart) {
      const chartStyle = chart.$refs.canvas.parentNode.style;
      chartStyle.heigth = this.chartSize;
      chartStyle.width = this.chartSize;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/stats/LoanStats.vue